import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const getVatNumbersRequest = payload =>
  actionRequestFactory(types.GET_VAT_NUMBERS_REQUEST, payload);
export const getVatNumbersSuccess = vatNumbers =>
  actionResponseFactory(types.GET_VAT_NUMBERS_SUCCESS, { vatNumbers });
export const getVatNumbersFailure = error =>
  actionResponseFactory(types.GET_VAT_NUMBERS_FAILURE, { error });

export const removeVatNumbers = () => actionResponseFactory(types.REMOVE_VAT_NUMBERS);

export const getFilingTypesRequest = payload =>
  actionRequestFactory(types.GET_FILING_TYPES_REQUEST, payload);
export const getFilingTypesSuccess = filingTypes =>
  actionResponseFactory(types.GET_FILING_TYPES_SUCCESS, { filingTypes });
export const getFilingTypesFailure = error =>
  actionResponseFactory(types.GET_FILING_TYPES_FAILURE, { error });

export const addSelectedFilingTypes = filingTypes =>
  actionResponseFactory(types.ADD_SELECTED_FILING_TYPES, { filingTypes });
export const removeAllFilingTypes = () => actionResponseFactory(types.REMOVE_ALL_FILING_TYPES);

export const getFilingStatusSuccess = filingStatus =>
  actionResponseFactory(types.GET_FILING_STATUS_SUCCESS, { filingStatus });
export const getFilingStatusFailure = error =>
  actionResponseFactory(types.GET_FILING_STATUS_FAILURE, { error });

export const addSelectedFilingStatus = filingStatus =>
  actionResponseFactory(types.ADD_SELECTED_FILING_STATUS, { filingStatus });
export const removeAllFilingStatus = () => actionResponseFactory(types.REMOVE_ALL_FILING_STATUS);

export const setBankingDetailsStart = payload => ({
  type: types.SET_BANKING_DETAILS_START,
  payload,
});
export const setBankingDetailsSuccess = payload => ({
  type: types.SET_BANKING_DETAILS_SUCCESS,
  payload,
});
export const setBankingDetailsFailure = () => ({
  type: types.SET_BANKING_DETAILS_FAILURE,
});
export const getBankingDetailsStart = payload => ({
  type: types.GET_BANKING_DETAILS_START,
  payload,
});
export const getBankingDetailsSuccess = payload => ({
  type: types.GET_BANKING_DETAILS_SUCCESS,
  payload,
});
export const getBankingDetailsFailure = payload => ({
  type: types.GET_BANKING_DETAILS_FAILURE,
  payload,
});

export const clearBankingDetails = () => ({
  type: types.CLEAR_BANKING_DETAILS,
});
